import React, { useState, useEffect, useRef } from "react";
import Carousel from "react-elastic-carousel";
import DeletePopup from "./Common/DeletePopup";
import { useDispatch, useSelector } from "react-redux";
import { removeFile } from "../Actions/uploadFileActions";

export default function ABCarousel(props) {
  const dispatch = useDispatch();
  const { items, record } = props;

  console.log(items);

  // const items=[
  //     {
  //         id: 1,
  //         src:
  //           "https://images.unsplash.com/photo-1627745193246-1fa1c9404b21?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
  //         alt: "The world"
  //       },
  //       {
  //         id: 2,
  //         src:
  //           "https://images.unsplash.com/photo-1631116617822-e100bd7e6e06?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
  //         alt: "Train"
  //       },
  //       {
  //         id: 3,
  //         src:
  //           "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=751&q=80",
  //         alt: "Laptop"
  //       }
  //   ];

  const [deleteItem, setdeleteItem] = useState();

  const handleRemoveClick = (e, id) => {
    e.preventDefault();
    setdeleteItem(id);
    setShowDeleteModal(1);

  };

  const [showDeleteModal, setShowDeleteModal] = useState(0);

  const closeDeleteModal = () => {
    setShowDeleteModal(0);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(1);
  };

  const deleteHandler = () => {
    setShowDeleteModal(1);
  };

  const proceedDelete = () => {
    const recordArray = {};
    recordArray.doc_chk = record.caseCheckId;
    recordArray.doc_ids = record.docId;
    recordArray.doc_ref = deleteItem;
    if(record["fldid"] !== undefined){
      recordArray.fldid = record.fldid;
      }

    //  //calling file upload api
    dispatch(removeFile("check_documents", recordArray, props?.uploadCallback));

    const newArr = removeObjectWithId(items, deleteItem);
    props.reRenderAgain();

    setShowDeleteModal(0);
  };

  function removeObjectWithId(arr, id) {
    const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
    arr.splice(objWithIdIndex, 1);

    return arr;
  }

  return (
    <>
      {/* <button onClick={()=>closeModal(false)}>X</button> */}

      {items.length > 0 ? (
        <>
          <Carousel>
            {items.map((item, key) => (
              <div
                key={key}
                id={item.id}
                className="d-flex flex-column align-items-center"
              >
                <img
                  src={item.image}
                  className="img-fluid"
                  style={{ height: "300px" }}
                />
                <button
                  class="btn btn-outline-secondary mt-3 mr-2"
                  onClick={(e) => handleRemoveClick(e, item.id)}
                >
                  <i class="far fa-trash-alt mr-2"></i>
                  Remove
                </button>
              </div>
            ))}
          </Carousel>

          {showDeleteModal === 1 && (
            <DeletePopup
              showModalBox={showDeleteModal}
              closePopup={closeDeleteModal}
              title="Delete Image"
              description="Are you sure you want to delete this image? This action cannot be undone."
              proceedHandler={proceedDelete}
              // record={record}
            />
          )}
        </>
      ) : (
        <>{/* <center>No item found</center> */}</>
      )}
    </>
  );
}
